import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import Appraisals from "./components/Appraisals/Appraisals";
import styled from "@emotion/styled";
import { BrowserRouter as Router, Route } from "react-router-dom";
import NotFound from "./components/NotFound";
import { useEffect } from 'react';
import { Routes } from '@datadog/browser-rum-react/react-router-v6';
import { initializeDatadogRum } from "./core/datadog";

initializeDatadogRum()

function App() {
	const Container = styled.div`
		width: 100%;
		margin: 0 auto;

		@media (min-width: 1025px) {
			width: 960px;
		}

		@media (min-width: 1200px) {
			width: 1160px;
		}

		background: white;
		transition: all linear 20ms;
	`;

	const handleRouteChange = () => {
		window.posthog?.capture("$pageview");
	};

	useEffect(() => {
		window.posthog?.capture("$pageview");
	}, [])

	return (
		<ThemeProvider theme={theme}>
			<Container>
				<Router onRouteChange={handleRouteChange}>
					<Routes>
						<Route path="appraisals" element={<Appraisals />} />
						<Route path="*" element={<NotFound />} />
					</Routes>
				</Router>
			</Container>
		</ThemeProvider>
	);
}

export default App;
